import React from 'react';
import ReactDOM from 'react-dom';
import MailingListSignup from './MailingListSignup';

require('es6-promise').polyfill();

Array.prototype.forEach.call(
  document.getElementsByClassName('mailing-list-signup'),
  function(el) {
    ReactDOM.render(<MailingListSignup />, el);
  }
);
